/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import BasicDetailsStock from '../../pages/markets/component/basic-details-stock';
import CalendarEvents from '../../pages/markets/component/calendar-events';
import FuturesGraphMobile from '../../pages/markets/component/futures-graph-mobile';
import StockNews from '../../pages/markets/component/stock-news';
import StockPageHeader from '../../pages/markets/pages/stock/header';
import StockVideos from '../../pages/markets/component/stock-videos';
import TodaysPriceStats from '../../pages/markets/component/todays-price-stats';
import TotalReturns from '../../pages/markets/component/total-returns';
import PromoterHoldings from '../../pages/markets/component/promoter-holdings';
import StockAnnouncements from '../../pages/markets/component/stock-announcements';
import StockResearchReports from '../../pages/markets/component/stock-research-reports';
import MovingAverages from '../../pages/markets/component/moving-averages';
import DeliveryVolumes from '../../pages/markets/component/delivery-volumes';
import QuarterlyResults from '../../pages/markets/component/quarterly-results';
import ShareHolding from '../../pages/markets/component/shareholding';
import CompareValuation from '../../pages/markets/component/compare-valuation';
import StockFundamentals from '../../pages/markets/component/stock-fundamentals';
import ComparePrice from '../../pages/markets/component/compare-price';
import StockGraph from '../../pages/markets/component/stock-graph';
import StockExclusives from '../../pages/markets/component/stock-exclusives';
import { QueryClient, QueryClientProvider } from 'react-query';
import { WithLazy } from '@quintype/components';
import MailmodoNewsLetter from '../../molecules/newsletter/mailmodo-news-letter';

import '../../pages/markets/pages/stock/stock.m.css';
import { fetchStockId } from '../../pages/markets/utils/marketsUtils';
import LiveTvWidget from '../../collection-templates/videos-list-collection/live-tv-widget';

const StockPageBase = (props) => {
  const [allStockDetails, setAllStockDetails] = useState([]);
  const [currentStock, setCurrentStock] = useState({});
  const queryClient = new QueryClient();

  useEffect(() => {
    const getAllStockDetails = async () => {
      const stockId = fetchStockId();
      const stockDetailsResponse = await fetch(`/next/feapi/stock/stock-details/${stockId}`);
      const stockDetailsData = await stockDetailsResponse.json();
      const stockArray = stockDetailsData?.filter(
        (stock) => stock?.STOCKID?.toString() === fetchStockId(),
      );
      setAllStockDetails(stockDetailsData);
      setCurrentStock(stockArray[0]);
    };
    getAllStockDetails();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        <div styleName="stock-page" className="container">
          <StockPageHeader myStock={currentStock} stockDetails={allStockDetails} {...props} />
        </div>

        <div styleName="background-container">
          <div styleName="stock-page" className="container">
            <div styleName="two-grid-fold">
              <div className="sidebar row-section">
                {allStockDetails && <BasicDetailsStock stockParentData={allStockDetails} />}
                <StockGraph />
              </div>
            </div>
          </div>
        </div>

        <div styleName="stock-page" className="container">
          <WithLazy>
            {() => (
              <div styleName="three-grid-fold">
                <div className="sidebar row-section">
                  <StockNews currentStock={currentStock} />
                  <StockResearchReports />
                  <div styleName="ad-widget-container">
                    <StockExclusives />
                  </div>
                </div>
              </div>
            )}
          </WithLazy>
          <WithLazy>
            {() => (
              <div styleName="three-grid-fold">
                <div className="sidebar row-section">
                  {currentStock && <ComparePrice currentStock={currentStock} />}
                  <CompareValuation />
                  <StockFundamentals />
                </div>
              </div>
            )}
          </WithLazy>

          <WithLazy>
            {() => (
              <div styleName="three-grid-fold">
                <div className="sidebar row-section">
                  <MovingAverages />
                  <DeliveryVolumes />
                  {currentStock && <TodaysPriceStats currentStock={currentStock} />}
                </div>
              </div>
            )}
          </WithLazy>

          <WithLazy>
            {() => (
              <div styleName="three-grid-fold">
                <div className="sidebar row-section">
                  <FuturesGraphMobile
                    maintainAspectRatio={false}
                    responsive={false}
                    flag="homepage"
                  />
                  <StockVideos currentStock={currentStock} />
                  <div styleName="video-newsletter-container">
                    <LiveTvWidget />
                    <MailmodoNewsLetter
                      title="All You Need To Know"
                      heading="Once Every Morning"
                      footerText1="We Promise. No Spam !"
                      footerText2="View All Newsletters"
                      page="market"
                    />
                  </div>
                </div>
              </div>
            )}
          </WithLazy>

          <WithLazy>
            {() => (
              <div styleName="two-grid-fold-alt">
                <div className="sidebar row-section">
                  <QuarterlyResults />
                  <TotalReturns currentStock={currentStock} />
                </div>
              </div>
            )}
          </WithLazy>

          <WithLazy>
            {() => (
              <div styleName="share-holding-container">
                <ShareHolding />
              </div>
            )}
          </WithLazy>

          <WithLazy>
            {() => (
              <div styleName="promoter-holding-container">
                <PromoterHoldings />
              </div>
            )}
          </WithLazy>

          <WithLazy>
            {() => (
              <div styleName="two-grid-fold">
                <div className="sidebar row-section">
                  {currentStock && <StockAnnouncements currentStock={currentStock} />}
                  <CalendarEvents />
                </div>
              </div>
            )}
          </WithLazy>
        </div>
      </>
    </QueryClientProvider>
  );
};

const StockFull = StockPageBase;

export default StockFull;
